import { createFileRoute } from '@tanstack/react-router'

import Footer from '../components/landing/Footer'
import "./legal.css"

export const Route = createFileRoute('/about')({
  component: AboutPage,
})

function AboutPage() {
  return (
    <div className="legal-page">
      <div className="legal-container">
        <h1 className="legal-title">About Modulus Sell</h1>
        
        <div className="legal-intro">
          <p>
            Modulus Sell is a comprehensive Supply Chain and Commerce Ecosystem. Moving beyond simple retail management, 
            this platform connects the entire value chain from raw material suppliers and manufacturers to distributors, 
            retailers, service providers, and end consumers.
          </p>
        </div>

        <div className="legal-section">
          <h2>Our Core Value Proposition</h2>
          <p>
            Modulus Sell simplifies business operations by consolidating detailed inventory tracking, billing, and online presence into a single, intuitive platform.
          </p>
          
          <h3>1. Operational Simplicity</h3>
          <p>
            We help micro and small businesses digitize and organize their day-to-day operations—including billing, 
            inventory tracking, and expense management—without requiring any accounting knowledge or complex ERP systems. 
            The interface is designed for non-technical users, ensuring that a business owner can manage their entire 
            operation from a smartphone.
          </p>

          <h3>2. Digital Identity & Social Commerce</h3>
          <p>
            Recognizing the shift towards social commerce, the platform empowers businesses to create their own brand 
            identity. With a single click, users can generate a professional, standalone e-commerce website. 
            This feature is vital for Instagram brands that need a dedicated link to share with customers, moving them 
            from chaotic DM-based orders to a structured checkout process.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  )
}
